import React, { useEffect, useState } from 'react';
import { loadReport } from '../../services/api';
import Loader from '../../utils/Loader';
import './ReportModal.css';
import './ReportStyles.css';

const ReportModal = ({ 
  isOpen, 
  onClose, 
  report, 
  reportType = "on_demand" // "on_demand" for playground, "on_schedule" for reports page
}) => {
  const [reportContent, setReportContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReport = async () => {
      if (!isOpen || !report) return;
      
      setLoading(true);
      setError(null);
      setReportContent(null);
      
      try {
        const reportId = report.report_id || report.id;
        const data = await loadReport(reportId, reportType);
        setReportContent(data);
      } catch (err) {
        setError(err.detail || 'Failed to load report');
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [isOpen, report, reportType]);

  // Close modal on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="report-modal-overlay" onClick={onClose}>
      <div className="report-modal" onClick={(e) => e.stopPropagation()}>
        {loading ? (
          <div className="report-modal-loading">
            <Loader size="large" text="Loading report content..." />
          </div>
        ) : error ? (
          <div className="report-modal-error">
            {error}
          </div>
        ) : reportContent ? (
          <div 
            className="report-modal-body scrollable-compact"
            dangerouslySetInnerHTML={{ __html: reportContent }}
          />
        ) : (
          <div className="report-modal-empty">
            No content available for this report.
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportModal;
